import { Points, Raycaster, Vector2, Vector3 } from 'three'

function Raycast(cameraManager) {
  if (!cameraManager) {
    throw new Error('cameraManager is required')
  }
  this.cameraManager = cameraManager;
  this.mouse = new Vector2();
  this.raycaster = new Raycaster();
  this.raycaster.params.Points.threshold = 10;

  this.getObjects = (position, target) => {
    this.mouse.copy(position)

    this.raycaster.setFromCamera(this.mouse, this.cameraManager.camera);
    let intersects = []
    if (typeof target.length !== 'undefined') {
      intersects = this.raycaster.intersectObjects(target);
    } else {
      intersects = this.raycaster.intersectObject(target);
    }

    if (intersects.length > 0) {
      return intersects[0];
    }
    return null
  }
}

export { Raycast }
